<form [formGroup]=form>
    <h4 class="bk-modal__section-title">
        {{'Calculate Legume Cover Crop N Credits' | translate }}
    </h4>

    <mat-form-field  appearance="fill"
        class="mat-form-field--one-line mat-form-field--short">

        <mat-label>
            {{'Legume Cover Crop Stand' | translate }}
        </mat-label>

        <mat-select required
            name="LegumeCoverCropStand"
            formControlName="LegumeCoverCropStand">

            <mat-option *ngFor="let standOption of standOptions"
                [value]="standOption.key">
                {{standOption.value}}
            </mat-option>

        </mat-select>
    </mat-form-field>

    <mat-form-field  appearance="fill"
        class="mat-form-field--one-line mat-form-field--short">

        <mat-label>
            {{'Incorporation Method' | translate }}
        </mat-label>

        <mat-select required
            name="IncorporationMethod"
            formControlName="IncorporationMethod">

            <mat-option *ngFor="let incorporationMethodOption of incorporationMethodOptions"
                [value]="incorporationMethodOption.key">
                {{incorporationMethodOption.value}}
            </mat-option>

        </mat-select>
    </mat-form-field>

    <!-- footer -->
    <div class="bk-modal__section-buttons">
        <button class="bk-button bk-button--medium bk-button--text-only"
            (click)="cancel($event)">
            {{'Cancel' | translate }}
        </button>
        <button class="bk-button bk-button--medium"
            [disabled]='form.invalid'
            (click)="calculate($event)">
            {{'Calculate' | translate }}
        </button>
    </div>
</form>